<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">Import file</span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" alt="Close button" />
    </button>
  </div>

  <div class="body-modal cutomBtn-margin">
    <p class="import-file-name" *ngIf="fileName">
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> {{ fileName }}
    </p>

    <form [formGroup]="importForm">
      <div class="form-group">
        <div class="services-form">
          <input
            type="text"
            formControlName="version"
            [maxlength]="maxVersionLength"
            placeholder="Version"
          />
          <label>Version</label>
        </div>
        <div
          class="input-error"
          *ngIf="f['version']?.touched && f['version']?.errors?.['maxlength']"
        >
          Version cannot exceed {{ maxVersionLength }} characters.
        </div>
      </div>

      <div class="form-group">
        <div class="services-form">
          <textarea
            formControlName="comment"
            class="resizable-textarea"
            rows="4"
            [maxlength]="maxCommentLength"
            placeholder="Comment"
          ></textarea>
          <label>Comment</label>
        </div>
        <div
          class="input-error"
          *ngIf="f['comment']?.touched && f['comment']?.errors?.['maxlength']"
        >
          Comment cannot exceed {{ maxCommentLength }} characters.
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      (click)="onImport()"
      [disabled]="submitting || importForm.invalid"
    >
      Import
    </button>
  </div>
</div>
